import { vendorNameOrHouse } from "@ardept/design-system";
import type { MeResponse } from "../api/types.js";

/**
 * #3408 — the vendor wordmark the console's nav rail wears.
 *
 * The same rule as the tab title (`brandedConsoleTitle` in `consoleTitle.ts`): a signed-in person whose `/me` carries their
 * sole tenant's `branding.vendor_name` sees that tenant's vendor; everyone else — every house operator, every
 * platform admin, any principal over more than one tenant (the engine sends no branding to them), and anyone
 * before `/me` answers — sees the house name, byte-identical to the rail before the prop existed. Pure, so it
 * is tested without a DOM.
 */
export function railVendorName(
  me: Pick<MeResponse, "is_platform_admin" | "allowed_tenant_ids" | "tenant_branding"> | undefined,
): string {
  if (!me || me.is_platform_admin || me.allowed_tenant_ids.length !== 1) return vendorNameOrHouse(undefined);
  return vendorNameOrHouse(me.tenant_branding?.vendor_name);
}
